<mat-sidenav-container style="height: 100%;" autosize>

  <mat-sidenav *ngIf="autorizacoes.gerenciarPermissoes" mode="over" position="end" [fixedInViewport]="true"
    (closedStart)="aoFecharSidebar()">

    <app-sidebar-permissoes [perfilSelecionado]="perfilSelecionado" (fecharSidebar)="fecharSidebar()"
      (permissoesAlteradas)="getPerfis(true)">
    </app-sidebar-permissoes>

  </mat-sidenav>

  <mat-sidenav-content>
    <app-page-container>
      <div class="opcoes">
        <div class="titulo">
          <span>Gestão de Acessos</span>
        </div>

        <div class="tab-navegacao">
          <button *ngIf="autorizacoes.listarUsuarios" routerLink="/gestao-de-acesso" class="ml-4">Usuários</button>
          <button *ngIf="autorizacoes.listarPerfis" class="button__color">Perfis</button>
        </div>

        <div class="sub-titulo my-2">
          Perfis
        </div>

        <form [formGroup]="filtraForm" class="form-inline my-2 my-lg-0">
          <div class="d-flex mb-4 justify-content-between">
            <div class="w-25">
              <input class="form-control mr-sm-2 my-sm-0" type="search" placeholder="Pesquisar..." aria-label="Search"
                formControlName="nome">
            </div>
            <app-botao-incluir *ngIf="autorizacoes.controlarPerfis" (click)="cadastrarPerfil()"
              [title]="'Adicionar novo perfil'">
            </app-botao-incluir>
          </div>
        </form>
        <app-tabela *ngIf="perfis.registros.length > 0; else retornoOSNA"
          [cabecalhos]="['ID', 'Descrição do Perfil', 'Nome', 'Permissões', 'Código', 'Ações']"
          [items]="perfis.registros" [colunasOcultas]="['Ações', 'Permissões']" [condicoesColunas]="[{ columnName: 'Ações', condition: autorizacoes.controlarPerfis },
                              { columnName: 'Permissões', condition: autorizacoes.gerenciarPermissoes }]">
          <tr *ngFor="let perfil of perfis.registros">
            <td>{{perfil.id}}</td>
            <td>{{perfil.descricao}}</td>
            <td>{{perfil.nome}}</td>
            <td *ngIf="autorizacoes.gerenciarPermissoes">
              <a *ngIf="token.perfilId !== perfil.id" class="gerenciar-permissao"
                (click)="abrirSidebar(perfil)">Gerenciar</a>
            </td>
            <td>{{perfil.codigo}}</td>
            <td *ngIf="autorizacoes.controlarPerfis">
              <div *ngIf="token.perfilId !== perfil.id" class="editar-excluir">
                <button (click)="editarPerfil(perfil)" class="editar__style">Editar</button>
                <button (click)="excluirPerfil(perfil)" class="excluir__style">Excluir</button>
              </div>
            </td>
          </tr>
        </app-tabela>
      </div>
      <app-paginacao nomeDaLista="Perfis" [(dados)]="perfis" (dadosChange)="getPerfis()"
        *ngIf="this.perfis.registros.length !== 0"></app-paginacao>
    </app-page-container>
  </mat-sidenav-content>

</mat-sidenav-container>
<ng-template #retornoOSNA>Não há registros.</ng-template>
<app-modal-cadastrar-perfil *ngIf="autorizacoes.controlarPerfis"
  (registerPerfil)="getPerfis()"></app-modal-cadastrar-perfil>
<app-modal-editar-perfil *ngIf="autorizacoes.controlarPerfis"
  (updatePerfil)="getPerfis(true)"></app-modal-editar-perfil>
<app-modal-excluir-perfil *ngIf="autorizacoes.controlarPerfis"
  (deletePerfil)="getPerfis(true)"></app-modal-excluir-perfil>